import api from './api';

export interface Tag {
  level1: string;
  level2?: string;
  level3?: string;
  count: number;
}

export const tagsApi = {
  fetchTags: () => api.get<Tag[]>('/notes/tags')
};

// 获取指定tag下的笔记
export const getNotesByTag = async (tagId: string) => {
  const response = await api.get(`/tags/${tagId}/notes`);
  return response.data;
}; 